import { IDomain, ILocale, IPortal, Maybe } from '@interfaces';
import { ICruiseSearchSort } from '../../../interfaces/cruise/ICruiseSearch';
import { log } from './logger';

import de from 'date-fns/locale/de';
import au from 'date-fns/locale/en-AU';
import nl from 'date-fns/locale/nl';

// Needs to be "var" to be global
// eslint-disable-next-line no-var
export var portal: IPortal;

// eslint-disable-next-line no-var
export var gtmId: string;

// eslint-disable-next-line no-var
export var ssrGtmId: string;

// eslint-disable-next-line no-var
export var htmlLang: string;

// eslint-disable-next-line no-var
export var defaultSortingString: ICruiseSearchSort;

export const portalLocales: Record<IPortal, ILocale> = {
    de: 'de-DE',
    fr: 'fr-FR',
    it: 'it-IT',
    nl: 'nl-NL',
    br: 'pt-BR',
    us: 'en-US',
    au: 'en-AU',
    cruiseaway: 'en-AU',
    c1au: 'en-AU',
    c1uk: 'en-GB',
};
export type ICurrencies = 'EUR' | 'USD' | 'AUD' | 'BRL' | 'GBP';
export const localeCurrency: Record<ILocale, ICurrencies | undefined> = {
    'de-DE': 'EUR',
    'fr-FR': 'EUR',
    'it-IT': 'EUR',
    'nl-NL': 'EUR',
    'pt-BR': 'BRL',
    'en-GB': 'GBP',
    'en-US': 'USD',
    'en-AU': 'AUD',
    'zh-CN': undefined,
};

export const portalUrls: Record<IPortal, IDomain> = {
    de: 'dreamlines.de',
    it: 'dreamlines.it',
    br: 'dreamlines.com.br',
    us: 'dreamlines.com',
    au: 'cruiseaway.com.au',
    cruiseaway: 'cruiseaway.com.au',
    c1uk: 'cruise1st.co.uk',
    c1au: 'cruise1st.com.au',
    fr: 'dreamlines.fr',
    nl: 'dreamlines.nl',
};

export interface ICountryOption {
    [key: string]: string;
}

export const countryCodeMap: ICountryOption = {
    c1au: 'au',
    c1uk: 'gb',
};

const defaultPortal: IPortal = 'de';

export const setPortal = (url: string | undefined): void => {
    if (!url) {
        log.debug(`SetPortal called with an empty url, defaulting to ${defaultPortal}`);
        portal = defaultPortal;
        return;
    }

    try {
        const detectedPortal = getMarketFromURL(url);
        // @TODO Fix this ASAP
        portal = detectedPortal === 'cruiseaway' ? ('au' as any) : detectedPortal;
    } catch (error) {
        portal = defaultPortal;
        log.debug(`Could not get portal from host "${url}", setting ${defaultPortal} as default`);
    }
};

export const setGtmId = (id: Maybe<string>): void => {
    if (!id) {
        log.warn(`SetGtmId called with an empty id. GTM script will not work`);
        return;
    }

    gtmId = id;
};

export const setSsrGtmId = (id: Maybe<string>): void => {
    if (!id) {
        log.warn(`ssrGtmId called with an empty id. GTM script will not work`);
        return;
    }

    ssrGtmId = id;
};

export const setHtmlLang = (lang: Maybe<string>): void => {
    if (!lang) {
        log.warn(`setHtmlLang called with an empty lang. The HTML lang will not be set`);
        return;
    }

    htmlLang = lang;
};

export const setDefaultSortingString = (sortingString: Maybe<ICruiseSearchSort>): void => {
    if (!sortingString) {
        log.error(
            `setDefaultSortingString called with an empty sorting string. The queries on cruise search will be insconsistent`,
        );
        return;
    }

    defaultSortingString = sortingString;
};

// Copied from shared/utils because external paths are cursed (or babel config misssing)
export const portalToLocale = (portal: IPortal): ILocale => {
    const locale = portalLocales[portal];
    if (!locale) throw new Error(`portalToLocale called with invalid portal ${portal}`);
    return locale;
};

export const getMarketFromURL = (url: string): IPortal => {
    for (const market in portalUrls) {
        if (url.toLowerCase().includes(portalUrls[market as IPortal])) {
            return market as IPortal;
        }
    }

    throw new Error(`Market in URL(${url}) not found`);
};

export const getDateAdapterLocale = (portal: ILocale) => {
    switch (portal) {
        case 'de-DE':
            return de;
        case 'en-AU':
            return au;
        case 'nl-NL':
            return nl;
        default:
            return de;
    }
};
